import { Dialog, makeStyles, useMediaQuery, DialogContent, useTheme, DialogTitle, Typography, Button } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import Lottie from 'react-lottie-player';

import animationData from "src/pages/ActionLayout/Finalize/anim_completion.json";
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      alignSelf: 'center',
      textAlign: 'center',
      paddingBottom: theme.spacing(4)
    },
    lottie: {
      height: 200
    },
    content: {
      lineHeight: '2em',
      padding: theme.spacing(3)
    }
  }
})
const ServiceFinishedPopup = ({ open = false }) => {
  const classes = useStyles()

  const [isOpen, setIsOpen] = useState(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const trackEvent = useTrackEvent()
  return (
    <Dialog open={isOpen} maxWidth="xs"  >
      <Lottie
        className={classes.lottie}
        play
        loop={0}
        animationData={animationData}
      />
      <DialogContent className={classes.root}>
        <Typography variant='h4'>
          Service is finished
        </Typography>
        <Typography variant='body1' className={classes.content}>
          Feedback is useful for us to improve our service. Please submit a review of your provider here
        </Typography>
        <Button variant='contained' size="large" color='primary' onClick={() => {
          trackEvent('Rating - Rated', {})
          setIsOpen(false)
        }}>Rate</Button>
      </DialogContent>
    </Dialog>
  )
}

export { ServiceFinishedPopup }